<template lang="pug">
div
  .task-List
    Icon(type="md-close",size='26').icon1(@click='$emit("goHome")')
    //- .left
    //-   div.task-title 我的任务
    .rigth
      //- RadioGroup(type="button",v-model='type')
      //-   Radio(label='全部')
      //-   Radio(label='未读')
      .task-title 我的任务
      ul
        li(v-for='v in this.$store.state.doCase.taskList').task-list
          i.icon-xiaoxitongzhitixinglingshenglingdang-xianxing.iconfont.icon
          span.content {{v.content}}
          span.time  {{v.createdTime}}
          //- span.delete(@click='fun_delete(v)') 删除
  div.Template
</template>
<script>
export default {
  data() {
    return {
      type: "全部",
      step: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"]
    };
  },
  methods: {
    queryTsak(id, v, index) {
      /** 查询所有任务列表 */
      const data = {
        chId: id
      };
      this.$http.listTaskByChid(data).then(res => {
        this.taskList = res.data.data;
        const find = value => {
          return v.taskId === value.id;
        };
        if (res.data.data.find(find)) {
          /** 需要跳转到本环节下的某个任务 */
          this.$emit("gotoTask", {
            taskIndex: res.data.data.findIndex(find),
            stageIndex: this.step.indexOf(index)
          });
        }
      });
    },
    goto(v) {
      /** 跳轉頁面到某一个任务下 */

      const data = this.$parent.doCase.caseData;
      // eslint-disable-next-line no-unused-vars
      let index = 0;
      // eslint-disable-next-line no-restricted-syntax
      for (const iterator of Object.keys(data)) {
        this.queryTsak(data[iterator].tsId, v, iterator);
        index += 1;
      }
    },
    fun_delete(value) {
      const data = {
        ids: JSON.stringify([value.id])
      };
      this.$http.batchDeletingNotification(data).then(res => {
        if (res.data.success) {
          this.$Message.success("删除成功!");
          this.$emit("del");
        }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.Template
  position fixed
  height 100vh
  width 100vw
  left 0
  top 0
  background rgba(0, 0, 0, 0.3)
  z-index 101
.task-List
  position fixed
  top 108px
  left 18.5%
  bottom 40px
  right 18.5%
  margin auto
  background #ffffff
  border-radius 4px
  z-index 102
  .icon1
    position fixed
    right 26px
    top 26px
    color #ffffff
    cursor pointer
  .rigth
    text-align left
    position absolute
    width 100%
    overflow auto
    height 100%
    right 0
    padding 32px
    z-index 4
    .task-title
      font-size 20px
      font-family MicrosoftYaHeiUI-Bold
      font-weight bold
      color rgba(42, 46, 54, 1)
      line-height 25px
      margin-bottom 16px
    .task-list
      height 50px
      line-height 50px
      font-size 14px
      font-family MicrosoftYaHeiUI
      color rgba(42, 46, 54, 1)
      background rgba(255, 255, 255, 1)
      display flex
      align-items center
      box-shadow 0px -1px 0px 0px #e6e6e6
      &:last-child
        border-bottom 1px solid #d6d6d6
      .content
        flex 1
        white-space nowrap
        text-overflow ellipsis
        overflow hidden
        cursor pointer
      .icon
        color #508FF4
        font-size 24px
        margin-right 16px
      .time
        flex 0.2
        font-size 14px
        font-family MicrosoftYaHeiUI
        color rgba(153, 153, 153, 1)
        line-height 18px
      .delete
        cursor pointer
        color rgba(56, 133, 225, 1)
</style>
